/// <amd-module name="Artifacts/PackageRecycleBin/components/EmptyRecycleBinModal" />

import {
  IPackageRecycleBinModuleState,
  PackageRecycleBinReduxModule,
} from "Artifacts/PackageRecycleBin/redux/Index";
import * as Res from "Artifacts/PackageRecycleBin/Resources";
import { ErrorBannerLoader } from "Artifacts/Root/components/ErrorBannerLoader";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { isLoading } from "Artifacts/Root/helpers/ComponentStateHelpers";
import { connectDynamicModules } from "Artifacts/Root/redux";
import * as React from "react";
import { connect } from "react-redux";
import { Dialog } from "VSSUI/Dialog";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

export interface IEmptyRecycleBinModalProps {
  onDismiss: () => void;
  onEmptyRecycleBin: () => void;
}

interface IMapStateToProps {
  emptyButtonState: ComponentState;
}

export const EmptyRecycleBinModalId = "EmptyRecycleBinModal";

const EmptyRecycleBinModal: React.FC<IEmptyRecycleBinModalProps & IMapStateToProps> = ({
  onDismiss,
  onEmptyRecycleBin,
  emptyButtonState,
}) => {
  return (
    <Dialog
      titleProps={{ text: Res.EmptyRecycleBin_Button }}
      onDismiss={onDismiss}
      footerButtonProps={[
        {
          text: Res.EmptyRecycleBin_Button,
          danger: true,
          onClick: onEmptyRecycleBin,
          iconProps: isLoading(emptyButtonState)
            ? {
                render: (className) => <Spinner className={className} size={SpinnerSize.small} />,
              }
            : undefined,
        },
        { text: Res.EmptyRecycleBinModal_Close, onClick: onDismiss },
      ]}
    >
      <ErrorBannerLoader state={emptyButtonState} noLoadingSpinner>
        {Res.EmptyRecycleBinModal_Body}
      </ErrorBannerLoader>
    </Dialog>
  );
};

const mapStateToProps = (state: IPackageRecycleBinModuleState) => {
  const hubState = state.packageRecycleBinState;
  return {
    emptyButtonState: hubState.emptyButtonState,
  };
};

const ConnectedEmptyRecycleBinModal = connectDynamicModules(
  connect(mapStateToProps)(EmptyRecycleBinModal),
  PackageRecycleBinReduxModule,
);

registerModal(EmptyRecycleBinModalId, ConnectedEmptyRecycleBinModal);

export { EmptyRecycleBinModal };
